module.exports = __webpack_public_path__ + "static/media/clouds.0a1169a5.gif";